import React from "react";

import CheckBox from "../../../../../components/CheckBoxes/CheckBox";

export type RouteSelectionState = "checked" | "indeterminate" | "unchecked";

export default function RouteSelectionCheckbox({
  state,
  label,
  testId,
  disabled = false,
  className = "",
  onChange,
}: {
  state: RouteSelectionState;
  label: string;
  testId: string;
  disabled?: boolean;
  className?: string;
  onChange: () => void;
}) {
  return (
    <label
      className={`relative block h-5 w-5 shrink-0 ${
        disabled ? "cursor-not-allowed opacity-40" : "cursor-pointer"
      } ${className}`}
      onClick={(event) => event.stopPropagation()}
    >
      <input
        type="checkbox"
        aria-label={label}
        data-testid={testId}
        disabled={disabled}
        checked={state === "checked"}
        ref={(element) => {
          if (element) element.indeterminate = state === "indeterminate";
        }}
        onChange={onChange}
        className={`absolute inset-0 z-10 h-5 w-5 opacity-0 ${
          disabled ? "cursor-not-allowed" : "cursor-pointer"
        }`}
      />
      <div aria-hidden="true">
        {/* Indeterminate means only some routes in this group or season are selected, so the checkbox displays a dash instead of a checkmark. */}
        <CheckBox
          checked={state === "checked"}
          indeterminate={state === "indeterminate"}
          className="pointer-events-none m-0"
        />
      </div>
    </label>
  );
}
